import { render, staticRenderFns } from "./DeviceDiagnose.vue?vue&type=template&id=2350bdf8"
import script from "./DeviceDiagnose.vue?vue&type=script&lang=js"
export * from "./DeviceDiagnose.vue?vue&type=script&lang=js"
import style0 from "./DeviceDiagnose.vue?vue&type=style&index=0&id=2350bdf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports